import { IterableElement } from 'type-fest'

import { Ticker } from './ticker'

export const FIAT_TICKERS = [Ticker.USD, Ticker.EUR, Ticker.UAH]

export type FiatTicker = IterableElement<typeof FIAT_TICKERS>
